import React, { useEffect, useRef, useState } from "react";
import styles from "./GridItemSidesImage.module.css";
import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";
const GridItemSidesImage = ({
  photo,
  id,
  removeCallback,
  uploadCallback,
  selectedCallback,
  zoomLevelCallback,
}) => {
  const [zoomLevel, setZoomLevel] = useState(photo?.zoomLevel);
  const [isPanning, setPanning] = useState(false);

  const containerRef = useRef(null);

  const [image, setImage] = useState();
  const [position, setPosition] = useState({
    oldX: 0,
    oldY: 0,
    x: 0,
    y: 0,
    z: 1,
  });

  const onMouseDown = (e) => {
    e.preventDefault();
    setPanning(true);
    setPosition({
      ...position,
      oldX: e.clientX,
      oldY: e.clientY,
    });
  };
  useEffect(() => {
    console.log("mouse moving");
    const mouseup = () => {
      setPanning(false);
    };

    const mousemove = (event) => {
      if (isPanning) {
        let newX = position.x + event.clientX - position.oldX;
        let newY = position.y + event.clientY - position.oldY;
        setPosition({
          ...position,
          x: newX,
          y: newY,
          oldX: event.clientX,
          oldY: event.clientY,
        });
      }
    };

    window.addEventListener("mouseup", mouseup);
    window.addEventListener("mousemove", mousemove);

    return () => {
      window.removeEventListener("mouseup", mouseup);
      window.removeEventListener("mousemove", mousemove);
    };
  });
  const onLoad = (e) => {
    setImage({
      width: e.target.naturalWidth,
      height: e.target.naturalHeight,
    });
  };
  const zoom = (val) => {
    if ((zoomLevel === 6 && val < 0) || (zoomLevel === 1 && val > 0)) {
      return;
    } else {
      setZoomLevel(val < 0 ? zoomLevel + 1 : zoomLevel - 1);
    }

    const sign = val;
    const scale = 1 - sign;
    const rect = containerRef.current.getBoundingClientRect();
    const cx = (rect["left"] + rect["right"]) / 2;
    const cy = (rect["top"] + rect["bottom"]) / 2;

    setPosition({
      ...position,
      x: position.x * scale - (rect.width / 2 - cx + rect.x) * sign,
      y:
        position.y * scale -
        ((image.height * rect.width) / image.width / 2 - cy + rect.y) * sign,
      z: val > 0 && zoomLevel - 2 === 0 ? 1 : position.z * scale,
    });
  };

  if (photo?.src === "") {
    return (
      <div
        style={{ height: "300px", width: "300px", position: "relative" }}
        className={`overflow-hidden ${
          photo?.id === "5" ? "ignoreDrag ignore" : "dragHandle dropArea"
        } ${styles.image_not_selected}`}
        draggable={photo?.id === "5" ? false : true}
        ref={containerRef}
        onClick={() => uploadCallback(1, photo?.id)}
      >
        <div
          onClick={(event) => {}}
          className={styles.upload_image_placeholder}
        >
          <img
            className={styles.upload_image_gallery_icon}
            src={gallery_icon}
            alt="top_gallery"
          />

          <div className={styles.upload_image_placeholder_text}>写真選択</div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        height: "300px",
        width: "300px",
        position: "relative",
        zIndex: photo?.photoSelected ? "8" : "3",
      }}
      className={`overflow-hidden ${
        photo?.id === "5" ? "ignoreDrag ignore" : "dragHandle dropArea"
      } 
      `}
      draggable={isPanning ? false : photo?.id === "5" ? false : true}
      ref={containerRef}
      onClick={() => {
        if (photo?.id !== -1 && !photo?.photoSelected) {
          console.log("Comes to photoselected");
          selectedCallback(photo?.id);
          setPanning(true);
        }
      }}
    >
      {photo?.photoSelected && (
        <div
          data-html2canvas-ignore="true"
          className={styles.border_container}
        ></div>
      )}

      <div className={styles.pan_and_zoom_container}>
        <div
          style={{
            transform: `translate(${position.x}px, ${position.y}px) scale(${position.z})`,
          }}
        >
          <img
            src={photo?.src}
            crossOrigin="anonymous"
            alt="pic"
            onLoad={onLoad}
            className={`${photo?.photoSelected ? styles.selected : ""} ${
              styles.img_original
            }`}
            onMouseDown={onMouseDown}
            onMouseUp={() => {
              selectedCallback(photo?.id);
            }}
          />
        </div>
      </div>
      <div
        onClick={() => {
          console.log("calling callback");
          console.log(photo?.id);
          removeCallback(photo?.id);
          //   console.log("Cross the image");
        }}
        data-html2canvas-ignore="true"
        className={styles.cross_div}
      >
        <ion-icon className={styles.cross_icon} name="close"></ion-icon>
      </div>
      {photo?.photoSelected && (
        <>
          <p
            data-html2canvas-ignore="true"
            className={`${styles.panning_icon} text-danger`}
            onClick={() => selectedCallback(-1)}
          >
            編
          </p>
          <div data-html2canvas-ignore="true" className={styles.zoom_section}>
            <i
              onClick={() => {
                zoom(0.1);
              }}
              className={
                "fa fa-search-minus " +
                styles.zoom_icon +
                " " +
                styles.minus_icon
              }
              aria-hidden="true"
            ></i>
            <i
              onClick={() => {
                zoom(-0.1);
              }}
              className={
                "fa fa-search-plus " + styles.zoom_icon + " " + styles.plus_icon
              }
              aria-hidden="true"
            ></i>
          </div>
        </>
      )}
    </div>
  );
};

export default GridItemSidesImage;
